import React, { useState, useEffect, useContext } from "react"
import { Link } from "react-router-dom"
import { LinkContainer } from "react-router-bootstrap"
import logo from "../img/UAI-Logo-dark.png"
import { InputGroup, Form, Dropdown } from "react-bootstrap"
import PeriodoModal from "./PeriodoModal"
import ImpersonarModal from "./ImpersonarModal"
import UAI from "../UAI"
import "./UAINavbar.css"
import { UsuarioContext } from "../Context/Usuario"
import { FaRegCalendarAlt } from "react-icons/fa"
import log from "loglevel"
import { FiSearch } from "react-icons/fi"
import { MdNotifications } from "react-icons/md"
import NotificacionesModal from "./NotificacionesModal"

/**
 * Barra de navegación de la aplicación. Muestra usuario y links a funcionalidades dependiendo de permisos.
 **/
const UAINavbar = (props) => {
  const { usuario } = useContext(UsuarioContext)

  const [isOpen, setIsOpen] = useState(false)
  const [modalPeriodoOpen, setModalPeriodoOpen] = useState(false)
  const [modalImpersonarOpen, setModalImpersonarOpen] = useState(false)
  const [modalNotificacionesOpen, setModalNotificacionesOpen] = useState(false)
  const [cohortesEncontrados, setCohortesEncontrados] = useState(null)

  useEffect(() => {
    let production = !(
      process.env.REACT_APP_ENVIRONMENT === "dev" ||
      process.env.REACT_APP_ENVIRONMENT === "staging" ||
      process.env.REACT_APP_ENVIRONMENT === "preprod"
    )

    if (props.usuarioAD && props.usuarioAD.authProvider && production) {
      let userpic = document.querySelector("#userpicture")
      if (userpic !== null) {
        document.querySelector("#userpicture").src = props.usuarioAD.userpic
        document.querySelector("#userpicture").classList.remove("d-none")
        document.querySelector("#username").classList.add("d-none")
      }
    }

    if (!usuario || (usuario && usuario.error) || props.loading) {
      return
    }
  }, [usuario, props.usuarioAD, props.loading])

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  const abrirModalPeriodo = () => {
    setModalPeriodoOpen(true)
  }
  const cerrarModalPeriodo = () => {
    setModalPeriodoOpen(false)
  }
  const abrirModalImpersonar = () => {
    setModalImpersonarOpen(true)
  }
  const cerrarModalImpersonar = () => {
    setModalImpersonarOpen(false)
  }

  return (
    <>
      <div className={"uainavbar sticky-top text-light"}>
        {(process.env.REACT_APP_ENVIRONMENT !== "prod" ||
          (usuario &&
            props.usuarioAD &&
            props.usuarioAD.username !== usuario.username)) && (
          <div className="alert-site">
            {process.env.REACT_APP_ENVIRONMENT !== "prod" && (
              <span className="environment" title={UAI.basePostula()}>
                {"Sandbox: " +
                  process.env.REACT_APP_ENVIRONMENT +
                  " - Postula: " +
                  UAI.basePostula() +
                  " - Usuario: " +
                  (props.usuarioAD ? props.usuarioAD.username : "")}
              </span>
            )}
            {usuario && props.usuarioAD.username !== usuario.username && (
              <span className="impersonar">
                {"impersonando a " + usuario.username}
              </span>
            )}
          </div>
        )}
        <div className="d-flex">
          <a href={UAI.wwwroot() + "/"}>
            <img
              className="uai-logo"
              src={logo}
              height="20"
              width="auto"
              alt="Universidad Adolfo Ibáñez"
            />
          </a>
          {usuario && !usuario.error && (
            <>
              <InputGroup size="sm">
                <InputGroup.Text>
                  <FiSearch />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Buscar cohortes..."
                  onChange={(e) => {
                    if (e.target.value.length >= UAI.largoMinimoBuscadorGeneral) {
                      let _cohortes = UAI.buscarCohortesPorVista(
                        e.target.value,
                        UAI.vistas["info-general"],
                        usuario
                      )
                      setCohortesEncontrados(_cohortes)
                      log.debug(_cohortes)
                    } else {
                      setCohortesEncontrados(null)
                    }
                  }}
                  onFocus={(e) => {
                    if (e.target.value.length >= UAI.largoMinimoBuscadorGeneral) {
                      let _cohortes = UAI.buscarCohortesPorVista(
                        e.target.value,
                        UAI.vistas["info-general"],
                        usuario
                      )
                      setCohortesEncontrados(_cohortes)
                    } else {
                      setCohortesEncontrados(null)
                    }
                  }}
                ></Form.Control>
                {cohortesEncontrados && (
                  <div className="buscador-resultados">
                    <ul>
                      {cohortesEncontrados.length === 0 && (
                        <li>No se encontraron cohortes</li>
                      )}
                      {cohortesEncontrados.map((coh) => {
                        let facultad = UAI.obtieneFacultadPorId(coh.facultad_id)
                        let urledicion =
                          (coh.esBorrador ? "/borrador" : "/cohorte") +
                          "/" +
                          coh.id
                        return (
                          <li key={coh.id}>
                            <Link
                              to={urledicion}
                              onClick={() => {
                                setCohortesEncontrados(null)
                                return true
                              }}
                            >
                              {facultad.key.toUpperCase() +
                              " - " + UAI.nombresGrados[coh.gradoid] +
                                " - " +
                                coh.nombre + " - " + coh.id}
                            </Link>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                )}
              </InputGroup>
            </>
          )}
          {usuario && (
            <div onClick={abrirModalPeriodo} role="button" className="periodo">
              <span className="icono-mp">
                <FaRegCalendarAlt />
              </span>
              {props.periodo}
            </div>
          )}
          {usuario && (
            <div
              onClick={() => {
                setModalNotificacionesOpen(true)
              }}
              role="button"
              className="periodo"
            >
              <span className="icono-mp">
                <MdNotifications />
                {usuario.notificaciones && usuario.notificaciones.length > 0 && (
                  <div className="notificaciones-usuario">
                    <div className="notificaciones-usuario-texto">
                      {usuario.notificaciones.length}
                    </div>
                  </div>
                )}
              </span>
            </div>
          )}
          <Dropdown align="end" className="usuario-dropdown">
            <Dropdown.Toggle variant="dark">
              <span id="username">{usuario ? usuario.usernameshort : ""}</span>
              <img
                id="userpicture"
                height="30"
                width="auto"
                className="d-none userpicture"
                alt={usuario ? usuario.username : ""}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {props.usuarioAD && (
                <LinkContainer className="nav-link" to="/perfil">
                  <Dropdown.Item>Perfil</Dropdown.Item>
                </LinkContainer>
              )}
              {props.usuarioAD &&
                UAI.permisosImpersonar[props.usuarioAD.username] && (
                  <LinkContainer
                    className="nav-link"
                    to="/"
                    hash="#"
                    onClick={abrirModalImpersonar}
                  >
                    <Dropdown.Item>Entrar como...</Dropdown.Item>
                  </LinkContainer>
                )}
              {usuario &&
                props.usuarioAD &&
                props.usuarioAD.username !== usuario.username &&
                UAI.permisosImpersonar[props.usuarioAD.username] && (
                  <LinkContainer
                    className="nav-link"
                    to="/"
                    hash="#"
                    onClick={() => {
                      props.CambiarUsuario(props.usuarioAD.username)
                    }}
                  >
                    <Dropdown.Item>
                      Volver a ser {props.usuarioAD.username}...
                    </Dropdown.Item>
                  </LinkContainer>
                )}
              {UAI.ayudaActivada && (
                <LinkContainer className="nav-link" to="/ayuda">
                  <Dropdown.Item>Ayuda</Dropdown.Item>
                </LinkContainer>
              )}
              {props.usuarioAD && (
                <>
                  <LinkContainer
                    className="nav-link"
                    to="/"
                    hash="#"
                    onClick={() => {
                      props.LimpiarCache()
                    }}
                  >
                    <Dropdown.Item>Limpiar caché</Dropdown.Item>
                  </LinkContainer>
                  <LinkContainer className="nav-link" to="/ayuda">
                    <Dropdown.Item>Ayuda</Dropdown.Item>
                  </LinkContainer>
                </>
              )}
              {props.usuarioAD && props.usuarioAD.logout && (
                <LinkContainer
                  className="nav-link"
                  to="/"
                  hash={"#"}
                  onClick={props.usuarioAD.logout}
                >
                  <Dropdown.Item>Cerrar sesión</Dropdown.Item>
                </LinkContainer>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <PeriodoModal
          show={modalPeriodoOpen}
          periodo={props.periodo}
          Cerrar={cerrarModalPeriodo}
          CambiarPeriodo={props.CambiarPeriodo}
        />
        <ImpersonarModal
          show={modalImpersonarOpen}
          Cerrar={cerrarModalImpersonar}
          CambiarUsuario={props.CambiarUsuario}
        />
        <NotificacionesModal
          show={modalNotificacionesOpen}
          cerrar={() => {
            setModalNotificacionesOpen(false)
          }}
        />
      </div>
    </>
  )
}

export default UAINavbar
